import TtsSwitch from './TtsSwitch'

export default TtsSwitch
